interface BfsCredentialStatus {
  configured?: boolean;
  dealershipConfigured?: boolean;
}

interface BfsDealerSettings {
  productMappings?: string;
}

export function hasConfiguredBfsProductMappings(value: string | null | undefined): boolean {
  const trimmed = value?.trim();
  if (!trimmed) return false;

  // A legacy single product ID applies to every policy prefix.
  if (!trimmed.startsWith('{')) return true;

  try {
    const parsed = JSON.parse(trimmed) as Record<string, unknown>;
    const mappings = Array.isArray(parsed['mappings']) ? parsed['mappings'] : [parsed];

    return mappings.some(mapping => {
      if (!mapping || typeof mapping !== 'object') return false;
      const candidate = mapping as Record<string, unknown>;
      const productId = typeof candidate['productId'] === 'string' ? candidate['productId'].trim() : '';
      const policyPrefixes = Array.isArray(candidate['policyPrefixes'])
        ? candidate['policyPrefixes'].filter(prefix => typeof prefix === 'string' && prefix.trim())
        : [];
      return Boolean(productId && policyPrefixes.length);
    });
  } catch {
    return false;
  }
}

export function isBfsCheckoutConfigured(
  credentialStatus: BfsCredentialStatus | null | undefined,
  dealerSettings: BfsDealerSettings
): boolean {
  return Boolean(
    credentialStatus?.configured &&
    credentialStatus.dealershipConfigured &&
    hasConfiguredBfsProductMappings(dealerSettings.productMappings)
  );
}
